import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { BusinessService } from '../../../services/business.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('menuEsquerdoAnimacao', [
      state('aberto', style({
        left: '0',
        opacity: 1
      })),
      state('fechado', style({
        left: '-270px',
        opacity: 1
      })),
      transition('fechado => aberto', [
        animate('0.3s 0.3s ease')
      ]),
      transition('aberto => fechado', [
        animate('0.2s 0.2s ease')
      ]),
    ]),
    trigger('menuDireitoAnimacao', [
      state('aberto', style({
        right: '0',
        opacity: 1
      })),
      state('fechado', style({
        right: '-270px',
        opacity: 1
      })),
      transition('fechado => aberto', [
        animate('0.3s 0.3s ease')
      ]),
      transition('aberto => fechado', [
        animate('0.2s 0.2s ease')
      ]),
    ]),
  ],
})
export class HeaderComponent implements OnInit {

  menuEsquerdoAberto = false;
  menuDireitoAberto = false;
  ajuda = false;
  private dentroComponente = false;
  mostraComoFaco: boolean = false;
  mostraPossoAjudar: boolean = false;

  constructor(private businessService: BusinessService) { }

  ngOnInit() {
  }

  mostraMenuEsquerdo() {
    this.menuEsquerdoAberto = !this.menuEsquerdoAberto;
    if(this.menuDireitoAberto) {
      this.menuDireitoAberto = !this.menuDireitoAberto;
    }
  }
  mostraMenuDireito() {
    this.menuDireitoAberto = !this.menuDireitoAberto;
    if(this.menuEsquerdoAberto) {
      this.menuEsquerdoAberto = !this.menuEsquerdoAberto;
    }
  }
  mostraAjuda() {
    this.ajuda = !this.ajuda;
    if(this.menuDireitoAberto) {
      this.menuDireitoAberto = !this.menuDireitoAberto;
    }
    if(this.menuEsquerdoAberto) {
      this.menuEsquerdoAberto = !this.menuEsquerdoAberto;
    }
  }

  navigateHapvidaHome() {
    var url = this.businessService.getBusinessUrl();
    if (url) {
      window.open(url, '_self');
    }
    return;
  }
}
